import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./chapterNavigationButton/ChapterNavigationButton.css";

export const ChapterNavigationButton = ({
  direction,
  financeUnlockedStyle,
  className,
  ...props
}) => {
  return (
    <span
      className={classnames(
        direction === "forward" && financeUnlockedStyle && styles.mirror,
        styles.iconWrapper,
      )}
    >
      {financeUnlockedStyle ? (
        <svg
          viewBox="0 0 16 20"
          overflow="visible"
          {...props}
          className={classnames(className, styles.svg, styles.icon)}
        >
          <switch>
            <g>
              <path fill="currentcolor" d="M3 8l13 8V0L3 8zM0 0v16h3V0H0z" />
            </g>
          </switch>
        </svg>
      ) : (
        <span
          className={classnames(
            className,
            styles.icon,
            direction === "forward"
              ? "icon-Smallarrow-Right"
              : "icon-Smallarrow-Left",
          )}
        />
      )}
    </span>
  );
};

ChapterNavigationButton.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(["back", "forward"]).isRequired,
  financeUnlockedStyle: PropTypes.bool,
};
